import styled from 'styled-components'

export const Button = styled.button`
    padding: 8px 16px;
    background: var(--blue-500);
    color: white;
    border-radius: 5px;
    border-color:var(--blue-500);
    cursor: pointer;
    white-space: nowrap;
    font-weight: 600;

    ${props => props.block ? 'display:block; width: 100%;' : ''}

    :hover{
        background: white;
        color:var(--blue-500);
        border: 1px solid var(--blue-500)
    }

`